import React from 'react';
import CustomToggleButton from '../../../shared/atoms/CustomToggleButton';
import { actuatorControlPropTypes } from '../../types';
import { secondaryColorObj } from '../../../../themes';
import CustomSelect from '../../../shared/atoms/CustomSelect';
import { Zigbee2MQTTUtils } from '../../../../utils/zigbeeUtils';

const TOGGLE_BUTTON_MAX_LENGTH = 6;

const exceededToggleButtonsLength = feature => {
  return feature.values.length >= TOGGLE_BUTTON_MAX_LENGTH;
};

const EnumControl = ({ mini, feature, value, handleChange }) => {
  const options = feature.values.map(value => ({
    value,
    content: value, // for CustomToggleButton
    label: value, // for CustomSelect
  }));

  if (!mini && !exceededToggleButtonsLength(feature))
    return (
      <CustomToggleButton
        value={value}
        handleChange={(_, newVal) => handleChange(feature.property, newVal)}
        options={options}
      />
    );

  return (
    <CustomSelect
      id={`actuator-enum-control-select-${feature.property}`}
      value={value || ''}
      onChange={e => handleChange(feature.property, e.target.value)}
      options={options}
      noLabel
      hideSelect={Zigbee2MQTTUtils.hasState(feature.access)}
      label="- - - -"
      sx={{
        width: '100% !important',
        '& select, & option': {
          lineHeight: mini ? 1 : 1.75,
          color: 'white !important',
          textTransform: 'uppercase',
        },
        '& select': {
          height: mini ? '24px' : '38.75px',
          border: 'none',
          background: secondaryColorObj.default,
          padding: '0px 1rem',
          textAlign: 'center',
        },
      }}
    />
  );
};

EnumControl.propTypes = actuatorControlPropTypes;

export default EnumControl;
